/* eslint-disable */

import axios from "axios-extra";

// 创建axios实例
const instance = axios.create({
  baseURL: "https://api-wfb-gxq.cdfirst.net/",
  timeout: 5000, // 请求超时时间
  maxConcurrent: 1, //并发为1
  queueOptions: {
    retry: 1, //请求失败时,最多会重试3次
    retryIsJump: true //是否立即重试, 否则将在请求队列尾部插入重试请求
  }
});

/**
 * 解决不能用axios.all
 * 参考 https://juejin.im/post/5ad192d2518825558c47dcbc
 */
instance.__proto__ = axios;

// request拦截器
instance.interceptors.request.use(config => {
  // console.log(
  //   "send request ==> " +
  //     config.url +
  //     ", " +
  //     localStorage.getItem("Authorization")
  // );
  if (localStorage.getItem("Authorization")) {
    config.headers.Authorization =
      "Bearer " + localStorage.getItem("Authorization");
  }
  return config;
});

// respone拦截器
instance.interceptors.response.use(
  response => {
    //console.log("response status = " + response.status);
    refreshToken(response);
    return Promise.resolve(response.data);
  },
  error => {
    //console.log("---> error response status: " + error.response.status);
    refreshToken(error.response);
    if (error.response.status) {
      switch (error.response.status) {
        case 401:
        case 403:
          // 清除用户缓存
          localStorage.clear();
          setTimeout(() => {
            window.location.href = "/#/login";
          }, 1000);
      }
    }
    return Promise.reject(error.response.data);
  }
);

function refreshToken(response) {
  if (response.headers && response.headers.authorization) {
    //console.log("token --> " + response.headers.authorization.slice(7));
    localStorage.setItem(
      "Authorization",
      response.headers.authorization.slice(7)
    );
  }
}

export default instance;
